module.exports = "/legacy/fe68ff7163cfdb8d6b16665a2000af0d.svg";